<template>
<div class="chapter">
<div class="inner_page">
<p class="tit1"><a id="page_1"></a><span class="bold">IMAGES OF WAR</span></p>
<h1 class="tit2"><span class="bold">WAFFEN-SS</span></h1>
<h1 class="tit3"><span class="bold">AT ARNHEM</span></h1>
<h1 class="tit4"><span class="bold">SEPTEMBER 1944</span></h1>
<p class="stit1"><span class="bold">RARE PHOTOGRAPHS FROM</span></p>
<p class="stit2"><span class="bold">WARTIME ARCHIVES</span></p>
<p class="author"><span class="bold">Ian Baxter</span></p>
<div class="img_containerp">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?641e994c